module.exports = __webpack_public_path__ + "static/media/sriracha-teen-hero-desktop.028b2e45.jpg";